import {
  Grid,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Timeline,
  Card,
  Tag,
  Switch,
  Checkbox,
  Typography,
  Progress,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import "./LearningGraphInfoModal.css";
import { useMobxStores } from "../stores/stores";
import { useEffect, useState } from "react";
import Loader from "./loaders/Loader";
import LinkOutPurple from "../assets/link-out-purple.png";
import { useLocation, useNavigate } from "react-router-dom";
import "./CatalogueItemDetailsModal.css";
import EditLearningGraphModalOneStep from "./EditLearningGraphModalOneStep";
import {
  RollbackOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import Icon from "@mdi/react";
import {
  mdiCodeBlockTags,
  mdiSchoolOutline,
  mdiTextBoxOutline,
  mdiCheck,
} from "@mdi/js";

import { mdiAccount } from "@mdi/js";

const { useBreakpoint } = Grid;
const levels = [
  {
    label: "Beginner",
    value: "beginner",
  },
  {
    label: "Intermediate",
    value: "intermediate",
  },
  {
    label: "Advanced",
    value: "advanced",
  },
  // {
  //   label: "Expert",
  //   value: "expert",
  // },
];

const LearningGraphInfoModal = ({
  learningGraphId,
  isOpen,
  setIsOpen,
  handleDelete,
  onCheckedMaterialsChange,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.lg; // < md = mobile

  const { catalogueStore, learningGraphStore } = useMobxStores();
  const [isEditing, setIsEditing] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const [learningGraph, setlearningGraph] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const [form] = Form.useForm();
  const learningTopic = Form.useWatch("learning_topic", form);
  const thematicField = Form.useWatch("thematic_field", form);
  const level = Form.useWatch("level", form);

  const [checkedMap, setCheckedMap] = useState({}); // { [materialId]: boolean }

  const totalSteps = learningGraph?.learning_materials?.length ?? 0;
  const completedSteps =
    learningGraph?.learning_materials?.filter(
      (m) => checkedMap[m.id ?? m.title],
    ).length ?? 0;

  const percent =
    totalSteps === 0 ? 0 : Math.round((completedSteps / totalSteps) * 100);

  // put near top (same file)
  const BLUE = "rgba(0, 0, 128, 1)";

  function StepDot({ index, completed }) {
    return (
      <div
        className={`step-dot ${completed ? "completed" : ""}`}
        style={{ borderColor: BLUE, fontWeight: 400 }}
      >
        {index + 1}
      </div>
    );
  }

  const mats = learningGraph?.learning_materials ?? [];

  // completed array in order
  const completedArr = mats.map((m) => !!checkedMap[m.id ?? m.title]);

  // last completed index (highest index that is true)
  const lastCompletedIndex = (() => {
    for (let i = completedArr.length - 1; i >= 0; i--) {
      if (completedArr[i]) return i;
    }
    return -1;
  })();
  useEffect(() => {
    const mats = learningGraph?.learning_materials || [];
    const initial = {};
    mats.forEach((m) => {
      // prefer m.id as key; fallback to title if you have no id (not ideal)
      initial[m.id ?? m.title] = !!m.completed;
    });
    setCheckedMap(initial);

    // also emit initial selection (optional but usually useful)
    // const selected = mats.filter((m) => initial[m.id ?? m.title]);
    // onCheckedMaterialsChange?.(learningGraph?.id, selected);
  }, [learningGraph?.learning_materials]);

  useEffect(() => {
    console.log("learningGraphId");
    console.log(learningGraphId);
    catalogueStore.GetUser();

    const getLearningGraph = async () => {
      const newData =
        await learningGraphStore.GetLearningGraph(learningGraphId);
      console.log(newData);
      setlearningGraph(newData);
    };
    getLearningGraph();
  }, []);

  useEffect(() => {
    if (!isEditing) {
      catalogueStore.GetUser();

      const getLearningGraph = async () => {
        const newData =
          await learningGraphStore.GetLearningGraph(learningGraphId);
        console.log(newData);
        setlearningGraph(newData);
      };
      getLearningGraph();
    }
  }, [!isEditing]);

  useEffect(() => {
    if (!isOpen || !learningGraphId) return;

    console.log("learningGraphId", learningGraphId);
    catalogueStore.GetUser();

    const getLearningGraph = async () => {
      const newData =
        await learningGraphStore.GetLearningGraph(learningGraphId);
      setlearningGraph(newData);

      console.log(learningGraph);
    };

    getLearningGraph();
  }, [isOpen, learningGraphId]);

  useEffect(() => {
    const hasEmptyFields =
      !learningTopic?.trim() || !thematicField?.trim() || !level;

    const isSame =
      learningTopic === learningGraph?.learning_topic &&
      thematicField === learningGraph?.thematic_field &&
      level === learningGraph?.level;

    setIsSaveDisabled(hasEmptyFields || isSame);
  }, [learningTopic, thematicField, level, learningGraph]);

  // const completed = (i) => i === 0 || i === 2;

  // if (!learningGraph) return <></>;

  return (
    <Modal
      // style={isMobile ? { maxWidth: "90vw" } : undefined}
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        setIsEditing(false);
        setIsOpen(false);
      }}
      // footer={

      // }
      footer={null}
      className="info-modal"
      centered
      width={isMobile ? "92vw" : 880}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {loading ? (
          <Loader />
        ) : (
          <div>
            {isEditing ? (
              <EditLearningGraphModalOneStep
                graphData={{
                  learning_topic: learningGraph?.learning_topic,
                  thematic_field: learningGraph?.thematic_field,
                  level: learningGraph?.level,
                  id: learningGraph?.id,
                  learning_materials: learningGraph?.learning_materials,
                  allData: learningGraph,
                  setEditing: () => setIsEditing(false),
                }}
              />
            ) : isMobile ? (
              <div
                style={
                  {
                    // marginTop: "12px",
                  }
                }
              >
                <>
                  <div className="catalogue-title-container">
                    <div>
                      <Row
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "8px",
                        }}
                      >
                        <div
                          className="catalogue-item-title"
                          style={{ flex: 1, minWidth: 0 }}
                        >
                          {" "}
                          {learningGraph?.learning_topic}{" "}
                        </div>
                        <div style={{ flexShrink: 0 }}>
                          {catalogueStore.user?.id === learningGraph?.creator &&
                          !loading
                            ? catalogueStore?.user.id ===
                                learningGraph?.creator && !isEditing
                              ? [
                                  <Button
                                    type="primary"
                                    onClick={() => setIsEditing(true)}
                                  >
                                    Edit
                                  </Button>,
                                  <Button
                                    onClick={handleDelete}
                                    style={{ marginLeft: "8px" }}
                                  >
                                    Delete
                                  </Button>,
                                ]
                              : isEditing
                                ? []
                                : null
                            : null}
                        </div>
                      </Row>
                      <Row
                        justify={"start"}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-10px",
                        }}
                      >
                        <Typography
                          className="catalogue-item-owner"
                          style={{ color: "rgb(090, 090, 090)" }}
                        >
                          {learningGraph?.thematic_field}
                        </Typography>
                      </Row>
                      <Row
                        justify={"start"}
                        style={{
                          marginTop: "22px",
                        }}
                        // style={{ display: "flex", alignItems: "center" }}
                      >
                        {" "}
                        <Icon path={mdiAccount} size={1.2} color="#000080 " />
                        <Typography
                          // className="catalogue-item-owner"
                          className="catalogue-item-url"
                          style={{
                            fontSize: "18px",
                          }}
                          onClick={() =>
                            navigate(
                              `/portfolio/${learningGraph?.creator_username}`,
                            )
                          }
                        >
                          {learningGraph?.creator_username}
                        </Typography>
                      </Row>
                      <Row
                        justify={"start"}
                        style={{
                          marginTop: "4px",
                        }}
                        // style={{ display: "flex", alignItems: "center" }}
                      >
                        <Typography
                          // className="catalogue-item-owner"
                          className="catalogue-item-url"
                          style={{
                            fontSize: "18px",
                            marginRight: "4px",

                            textDecorationLine: "none",
                            cursor: "default",
                            color: "rgb(208, 31, 223)",
                          }}
                        >
                          Level:
                        </Typography>
                        <Typography
                          // className="catalogue-item-owner"
                          className="catalogue-item-url"
                          style={{
                            fontSize: "18px",
                            textDecorationLine: "none",
                            cursor: "default",
                          }}
                        >
                          {learningGraph?.level}
                        </Typography>
                      </Row>
                    </div>
                  </div>
                </>
                <div style={{ marginTop: "28px" }}>
                  <Row
                    className="info-modal-headers"
                    style={{ marginBottom: "-18px" }}
                  >
                    Learning Outcomes
                  </Row>
                  <ul
                    className="catalogue-item-url"
                    style={{
                      background: " #d9d9d9",
                      textDecorationLine: "none",
                      cursor: "default",
                      color: "black",
                    }}
                    // className="info-modal-list"
                  >
                    {learningGraph?.educational_outcomes?.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                {/* Learning Steps */}
                <div style={{ marginTop: "18px" }}>
                  <Row
                    className="info-modal-headers"
                    style={{ marginBottom: "-12px" }}
                  >
                    Learning Steps
                  </Row>
                  <div
                    className="learning-steps-scroll mobile-steps-cards"
                    style={{
                      maxHeight: "320px",
                      overflowY: "auto",
                      marginTop: "12px",
                    }}
                  >
                    {(() => {
                      const mats = learningGraph?.learning_materials ?? [];

                      const completedArr = mats.map(
                        (m) => !!checkedMap[m.id ?? m.title],
                      );

                      const lastCompletedIndex = (() => {
                        for (let i = completedArr.length - 1; i >= 0; i--) {
                          if (completedArr[i]) return i;
                        }
                        return -1;
                      })();

                      return mats.map((item, index) => {
                        const key = item.id ?? item.title;
                        const completed = !!checkedMap[key];

                        const canCheck = index === 0 || completedArr[index - 1];
                        const canUncheck = index === lastCompletedIndex;
                        const disabled = completed ? !canUncheck : !canCheck;

                        return (
                          <div className="mobile-step-row" key={key}>
                            {/* circle outside card */}
                            <div
                              className={`step-dot ${
                                completed ? "completed" : ""
                              }`}
                            >
                              {index + 1}
                            </div>

                            <div
                              className={`mobile-step-card ${
                                completed ? "mobile-step-card-completed" : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                window.open(`/catalogue/${item.id}`, "_blank");
                              }}
                            >
                              <div className="mobile-step-title">
                                {item.title}
                              </div>

                              <Checkbox
                                className="mobile-step-checkbox"
                                checked={completed}
                                disabled={disabled}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => {
                                  // e.stopPropagation();
                                  const nextChecked = e.target.checked;

                                  if (nextChecked && !canCheck) return;
                                  if (!nextChecked && !canUncheck) return;

                                  setCheckedMap((prev) => {
                                    const next = {
                                      ...prev,
                                      [key]: nextChecked,
                                    };

                                    const selected = mats
                                      .filter((m) => next[m.id ?? m.title])
                                      .map((m) => m.id);

                                    onCheckedMaterialsChange?.(
                                      learningGraph.id,
                                      selected,
                                    );

                                    return next;
                                  });
                                }}
                              >
                                Completed
                              </Checkbox>
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
                {/* progress bar */}
                <div style={{ marginTop: 18 }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography.Text>
                      {completedSteps} / {totalSteps} completed
                    </Typography.Text>
                    <Typography.Text>{percent}%</Typography.Text>
                  </div>

                  <Progress percent={percent} showInfo={false} />
                </div>
              </div>
            ) : (
              <div
                style={
                  {
                    // marginTop: "12px",
                  }
                }
              >
                <>
                  <div className="catalogue-title-container">
                    <div>
                      <Row
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "8px",
                        }}
                      >
                        <div
                          className="catalogue-item-title"
                          style={{ flex: 1, minWidth: 0 }}
                        >
                          {" "}
                          {learningGraph?.learning_topic}{" "}
                        </div>
                        <div style={{ flexShrink: 0 }}>
                          {catalogueStore.user?.id === learningGraph?.creator &&
                          !loading
                            ? catalogueStore?.user.id ===
                                learningGraph?.creator && !isEditing
                              ? [
                                  <Button
                                    type="primary"
                                    onClick={() => setIsEditing(true)}
                                  >
                                    Edit
                                  </Button>,
                                  <Button
                                    onClick={handleDelete}
                                    style={{ marginLeft: "8px" }}
                                  >
                                    Delete
                                  </Button>,
                                ]
                              : isEditing
                                ? []
                                : null
                            : null}
                        </div>
                      </Row>
                      <Row
                        justify={"start"}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "-10px",
                        }}
                      >
                        <Typography
                          className="catalogue-item-owner"
                          style={{ color: "rgb(090, 090, 090)" }}
                        >
                          {learningGraph?.thematic_field}
                        </Typography>
                      </Row>
                      <Row
                        justify={"start"}
                        style={{
                          marginTop: "22px",
                        }}
                        // style={{ display: "flex", alignItems: "center" }}
                      >
                        {" "}
                        <Icon path={mdiAccount} size={1.2} color="#000080 " />
                        <Typography
                          // className="catalogue-item-owner"
                          className="catalogue-item-url"
                          style={{
                            fontSize: "18px",
                          }}
                          onClick={() =>
                            navigate(
                              `/portfolio/${learningGraph?.creator_username}`,
                            )
                          }
                        >
                          {learningGraph?.creator_username}
                        </Typography>
                      </Row>
                      <Row
                        justify={"start"}
                        style={{
                          marginTop: "4px",
                        }}
                        // style={{ display: "flex", alignItems: "center" }}
                      >
                        <Typography
                          // className="catalogue-item-owner"
                          className="catalogue-item-url"
                          style={{
                            fontSize: "18px",
                            marginRight: "4px",

                            textDecorationLine: "none",
                            cursor: "default",
                            color: "rgb(208, 31, 223)",
                          }}
                        >
                          Level:
                        </Typography>
                        <Typography
                          // className="catalogue-item-owner"
                          className="catalogue-item-url"
                          style={{
                            fontSize: "18px",
                            textDecorationLine: "none",
                            cursor: "default",
                          }}
                        >
                          {learningGraph?.level}
                        </Typography>
                      </Row>
                    </div>
                  </div>
                </>
                <div style={{ marginTop: "28px" }}>
                  <Row
                    className="info-modal-headers"
                    style={{ marginBottom: "-18px" }}
                  >
                    Learning Outcomes
                  </Row>
                  <ul
                    className="catalogue-item-url"
                    style={{
                      background: " #d9d9d9",
                      textDecorationLine: "none",
                      cursor: "default",
                      color: "black",
                    }}
                    // className="info-modal-list"
                  >
                    {learningGraph?.educational_outcomes?.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                {/* Learning Steps */}
                <div style={{ marginTop: "18px" }}>
                  <Row
                    className="info-modal-headers"
                    style={{ marginBottom: "-12px" }}
                  >
                    Learning Steps
                  </Row>
                  <div
                    className="learning-steps-scroll"
                    style={{
                      maxHeight: "160px",
                      overflowY: "auto",
                      marginTop: "12px",
                      // border: "2px solid red",
                    }}
                  >
                    <Timeline
                      // style={{ marginTop: "32px" }}
                      className="learning-steps-timeline"
                      items={(() => {
                        const mats = learningGraph?.learning_materials ?? [];

                        // completed status in order (same order as timeline)
                        const completedArr = mats.map(
                          (m) => !!checkedMap[m.id ?? m.title],
                        );

                        // last completed step index (only this one is allowed to be unchecked)
                        const lastCompletedIndex = (() => {
                          for (let i = completedArr.length - 1; i >= 0; i--) {
                            if (completedArr[i]) return i;
                          }
                          return -1;
                        })();

                        return mats.map((item, index) => {
                          const key = item.id ?? item.title;
                          const completed = !!checkedMap[key];

                          // rule 1: can check only if previous completed (or first)
                          const canCheck =
                            index === 0 || completedArr[index - 1];

                          // rule 2: can uncheck only the most recent completed step
                          const canUncheck = index === lastCompletedIndex;

                          // disable based on whether it's currently checked or not
                          const disabled = completed ? !canUncheck : !canCheck;

                          return {
                            dot: (
                              <StepDot index={index} completed={completed} />
                            ),
                            children: (
                              <div className="step-row">
                                {/* <div
                                  className="catalogue-item-url"
                                  style={{ marginTop: "-4px" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(
                                      `/catalogue/${item.id}`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  {item.title}
                                </div> */}

                                <Tooltip
                                  title={
                                    item.title?.length > 55 ? item.title : ""
                                  }
                                >
                                  <div
                                    className="catalogue-item-url"
                                    style={{ marginTop: "-4px" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      window.open(
                                        `/catalogue/${item.id}`,
                                        "_blank",
                                      );
                                    }}
                                  >
                                    {item.title?.length > 55
                                      ? `${item.title.slice(0, 55)}...`
                                      : item.title}
                                  </div>
                                </Tooltip>

                                <Checkbox
                                  style={{ marginTop: "-4px" }}
                                  checked={completed}
                                  disabled={disabled}
                                  onChange={(e) => {
                                    const nextChecked = e.target.checked;

                                    // extra safety (in case UI is bypassed)
                                    if (nextChecked && !canCheck) return;
                                    if (!nextChecked && !canUncheck) return;

                                    setCheckedMap((prev) => {
                                      const next = {
                                        ...prev,
                                        [key]: nextChecked,
                                      };

                                      const selected = mats
                                        .filter((m) => next[m.id ?? m.title])
                                        .map((m) => m.id);

                                      onCheckedMaterialsChange?.(
                                        learningGraph.id,
                                        selected,
                                      );
                                      return next;
                                    });
                                  }}
                                >
                                  Completed
                                </Checkbox>
                              </div>
                            ),
                          };
                        });
                      })()}
                    />
                  </div>
                </div>
                {/* progress bar */}
                <div style={{ marginTop: 18 }}>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography.Text>
                      {completedSteps} / {totalSteps} completed
                    </Typography.Text>
                    <Typography.Text>{percent}%</Typography.Text>
                  </div>

                  <Progress percent={percent} showInfo={false} />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default observer(LearningGraphInfoModal);
